import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { ReportDetail } from '@/features/reports/ReportDetail';
import { useTenant } from '@/lib/tenant';

function ReportDetailRoute() {
  const { slug, id } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <ReportDetail slug={slug} reportId={id} />;
}

export const Route = createFileRoute('/tenants/$slug/reports/$id')({
  component: ReportDetailRoute,
});
